// 认证工具
import storage from './storage'

export default {
    /**
     * 用户登录
     * @param {string} username - 用户名
     * @param {string} password - 密码
     * @returns {Object} { success: boolean, user?: Object, message?: string }
     */
    login(username, password) {
        const users = storage.get('users') || []
        const user = users.find(u => u.username === username && u.password === password)

        if (user) {
            storage.set('currentUser', user)
            return { success: true, user }
        }

        return { success: false, message: '用户名或密码错误' }
    },

    /**
     * 用户注册
     * @param {string} username - 用户名
     * @param {string} password - 密码
     * @returns {Object} { success: boolean, user?: Object, message?: string }
     */
    register(username, password) {
        const users = storage.get('users') || []

        // 检查用户名是否已存在
        if (users.find(u => u.username === username)) {
            return { success: false, message: '用户名已存在' }
        }

        // 创建新用户
        const newUser = {
            id: Date.now().toString(),
            username,
            password,
            role: 'user',
            balance: 0,
            status: 'active',
            profile: {
                fullName: '',
                phone: '',
                bankAccount: '',
                katakanaName: '',
                address: ''
            },
            profileComplete: false,
            createdAt: Date.now()
        }

        users.push(newUser)
        storage.set('users', users)

        return { success: true, user: newUser }
    },

    /**
     * 用户登出
     */
    logout() {
        storage.remove('currentUser')
    },

    /**
     * 设置当前登录用户
     * @param {Object} user - 当前用户对象
     */
    setCurrentUser(user) {
        storage.set('currentUser', user)
    },

    /**
     * 获取当前登录用户
     * @returns {Object|null} 当前用户对象或null
     */
    getCurrentUser() {
        return storage.get('currentUser')
    },

    /**
     * 检查是否已登录
     * @returns {boolean}
     */
    isLoggedIn() {
        return !!this.getCurrentUser()
    },

    /**
     * 检查是否是管理员
     * @returns {boolean}
     */
    isAdmin() {
        const user = this.getCurrentUser()
        return user && user.role === 'admin'
    },

    /**
     * 初始化认证系统（创建默认管理员账户）
     */
    init() {
        const users = storage.get('users') || []

        // 如果没有管理员账户，创建一个
        if (!users.find(u => u.role === 'admin')) {
            const adminUser = {
                id: 'admin',
                username: 'admin',
                password: 'admin123',
                role: 'admin',
                balance: 0,
                status: 'active',
                profile: {
                    fullName: '管理员',
                    phone: '',
                    bankAccount: '',
                    katakanaName: '',
                    address: ''
                },
                profileComplete: true,
                createdAt: Date.now()
            }
            users.push(adminUser)
            storage.set('users', users)
        }
    }
}
